module.exports = __webpack_public_path__ + "img/image_case_8.2be377a8.png";